(() => {
  if (window.afterFourAddFeedback) return;
  let flying, pulse, sequence = 0;
  const timers = new WeakMap();
  function visibleRect(element) {
    if (!element) return null;
    const r = element.getBoundingClientRect(), s = getComputedStyle(element);
    const vv=window.visualViewport,top=vv?.offsetTop||0,left=vv?.offsetLeft||0;
    if(!r.width||!r.height||s.visibility==='hidden'||s.display==='none')return null;
    const clipped={left:Math.max(r.left,left),top:Math.max(r.top,top),right:Math.min(r.right,left+(vv?.width||innerWidth)),bottom:Math.min(r.bottom,top+(vv?.height||innerHeight))};
    clipped.width=clipped.right-clipped.left;clipped.height=clipped.bottom-clipped.top;
    if(clipped.width<=0||clipped.height<=0)return null;
    const hit=document.elementFromPoint(clipped.left+clipped.width/2,clipped.top+clipped.height/2);
    return hit===element||element.contains(hit)?clipped:null;
  }
  const visible=element=>Boolean(visibleRect(element));
  window.afterFourAddFeedback = async ({button,image,count}) => {
    const current = ++sequence;
    try {
      const targets=[...document.querySelectorAll('.af-site-header__actions [aria-controls="cart-drawer"], .af-site-header__actions a[href$="/cart"]')];
      if(Number.isInteger(count))targets.forEach(n=>n.textContent=`BAG (${count})`);
      if(button){
        const saved=timers.get(button);if(saved)clearTimeout(saved.timer);
        const original=saved?.original||button.textContent;
        button.style.minWidth=`${button.getBoundingClientRect().width}px`;
        button.textContent='Added ✓';
        const timer=setTimeout(()=>{if(button.textContent==='Added ✓')button.textContent=original;button.style.minWidth='';timers.delete(button);},1200);
        timers.set(button,{timer,original});
      }
      flying?.remove();flying=null;pulse?.cancel();
      if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      const target=targets.find(visible);
      if(!target||!visible(button)||!image)return;
      const img=document.createElement('img');img.alt='';img.setAttribute('aria-hidden','true');
      // First use may be a cold image request: never animate an undecoded image.
      const source=new URL(image,location.href);
      if(source.hostname===location.hostname||source.hostname.endsWith('.shopify.com'))source.searchParams.set('width','160');
      img.src=source.href;
      const ready = await Promise.race([
        img.decode().then(()=>true).catch(()=>false),
        new Promise(resolve=>setTimeout(()=>resolve(false),2500))
      ]);
      if(!ready||current!==sequence||!visible(button)||!visible(target))return;
      const size=matchMedia('(max-width:749px)').matches?56:68;
      const from=visibleRect(button),to=visibleRect(target);
      if(!from||!to)return;
      const x=from.left+from.width/2-size/2,y=from.top+from.height/2-size/2;
      const dx=to.left+to.width/2-size/2-x,dy=to.top+to.height/2-size/2-y;
      Object.assign(img.style,{position:'fixed',left:`${x}px`,top:`${y}px`,width:`${size}px`,height:`${size}px`,objectFit:'contain',pointerEvents:'none',zIndex:'2147483646',borderRadius:'8px',background:'#fff',padding:'3px',boxShadow:'0 3px 12px rgba(22,36,58,.22)'});
      document.body.append(img);flying=img;
      const animation=img.animate([{transform:'translate(0,0) scale(1)',opacity:1},{transform:`translate(${dx*.5}px,${dy*.5-48}px) scale(.95)`,opacity:1,offset:.5},{transform:`translate(${dx*.88}px,${dy*.88}px) scale(.65)`,opacity:.9,offset:.88},{transform:`translate(${dx}px,${dy}px) scale(.4)`,opacity:0}],{duration:650,easing:'cubic-bezier(.25,.6,.35,1)'});
      animation.finished.catch(()=>{}).finally(()=>{img.remove();if(flying===img)flying=null;});
      pulse=target.animate([{opacity:1},{opacity:.6},{opacity:1}],{duration:350});
    } catch (_) { /* Presentation must never turn a successful add into an error. */ }
  };
})();
